import * as React from 'react';
import { safeHref } from '../helper';

export default function Actions({links}) {
  if (!links || !Array.isArray(links) || !links.length) return null;

  return (
    <div className='accordion-item__actions'>
      {links.map((link, idx) => {
        const href = safeHref(link.url);
        if (!href) return null;

        return <a key={idx} href={href} className='nv-cta-secondary nv-cta-secondary--small' rel='noopener noreferrer'>
          {link.text}
        </a>;
      })}
    </div>
  );
}
